export default __webpack_public_path__ + "static/media/SwamijiNew6.bbc2ba35.JPG";